import type { FC } from 'react';
import { useIntl } from 'react-intl';

import { ProgressBar } from '@xing-com/progress-bar';

import {
  StyledContainer,
  StyledHeadline,
  StyledHeadlineContainer,
  StyledLevelDescription,
  StyledLi,
} from './language-snippet.styles';

export type LanguageSnippetProps = {
  languageName: string;
  skillLevelId: number;
};

type LevelDescriptionProps = {
  level: number;
};

const LevelDescription: FC<LevelDescriptionProps> = ({ level }) => {
  const { formatMessage } = useIntl();

  return level > 0 && level < 5 ? (
    <StyledLevelDescription size="small">
      {formatMessage({ id: `PROFILE_LO_FE_LANGUAGE_SKILLS_LEVEL_${level}` })}
    </StyledLevelDescription>
  ) : null;
};

export const LanguageSnippet: FC<LanguageSnippetProps> = ({
  languageName,
  skillLevelId,
}) => {
  return (
    <StyledLi>
      <StyledHeadlineContainer>
        <StyledHeadline as="h3">{languageName}</StyledHeadline>
        <LevelDescription level={skillLevelId} />
      </StyledHeadlineContainer>
      <StyledContainer aria-hidden="true">
        <ProgressBar
          progress={skillLevelId === 1 ? 30 : 25 * skillLevelId}
          showLabel={false}
        />
      </StyledContainer>
    </StyledLi>
  );
};
